<template>
  <div class="con">
    <h1 class="title">如何获得恒通积分？</h1>
    <ul class="rules">
      <li>1.邀请分享+注册：20分（研值）</li>
      <li>2.签到：1分，分享：2分，连续签到多天更多奖励</li>
      <li>3.完善信息：20分</li>
      <li>4.自主录入积分/积分卡</li>
      <li>5.工具使用积分：2分/个/天（需要上限）</li>
      <li>6.课程消费：CFRA、CFWA、研习社（定额）、线上课</li>
      <li>7.推荐课程积分：CFWA10000分、CFRA300分</li>
    </ul>
  </div>

</template>

<script>
export default {
  name: 'ruleDetaile',
  data () {
    return {

    }
  },
  mounted(){

  },
  methods:{}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .con{
    padding: 0.3rem;
    padding-top:0.4rem;
  }
  .con h1.title{
    color: #333;
    font-size: 0.36rem;
    border-left: 2px solid #D7B177;
    padding-left: 0.2rem;
    line-height: 0.4rem;
    height: 0.4rem;
  }
  .rules{
    margin-top: 0.3rem;
  }
  .rules li{
    font-size: 0.28rem;
    color: #666666;
    margin-bottom: 10px;
  }

</style>



// WEBPACK FOOTER //
// src/components/ruleDetaile.vue